import { graphql } from 'react-relay';

const homepageRootQuery = graphql`
    query homepageRootQuery(
        $isMobile: Boolean!
        $homepageId: String!
        $userId: String!
        $hasUserId: Boolean!
        $isTrade: Boolean!
        $isClient: Boolean!
        $fetchInitialHomepage: Boolean!
        $userCountryCode: String
        $zipCode: String
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
    ) {
        viewer {
            ...HpRespLayout_viewer
            homepage(rootId: $homepageId) {
                ...getHomePageMetaContent_homepage @relay(mask: false)
            }
        }
    }
`;

const homepageVariables = {
    fetchInitialHomepage: true,
    hasRecentlyViewedItems: false,
    isMobile: false,
    homepageId: '',
    userId: '',
    hasUserId: false,
    isTrade: false,
    recentlyViewedItemIds: [],
    userIds: [],
    isClient: false,
    countryCode: '',
    zipCode: '',
};

export { homepageRootQuery, homepageVariables };
